import { useState } from 'react';

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      name: 'Baraka MK',
      role: 'Shoulder Pain Patient',
      quote: 'I had intense shoulder pain from a tight pec minor, but cupping at CareJoint changed everything! The therapy instantly released the tension, restored my range of motion, and got me back to moving pain-free. If you want fast, effective relief, this is it!',
      rating: 5,
    },
    {
      name: 'Kateeba Eddie',
      role: 'Local Guide',
      quote: 'I suffered from shoulder pain (Pec Minor tightness) for 8 months. After just 2 sessions of cupping at CareJoint, I felt better without any painkillers or massages! My recovery period was set for one month, and the relief has been incredible. Highly recommend for fast results!',
      rating: 5,
    },
    {
      name: 'Grace Namuli',
      role: 'Chronic Pain Patient',
      quote: 'I suffered from severe back pain for years. The pain management techniques at CareJoint have been life-changing. I can now enjoy daily activities without constant discomfort.',
      rating: 5,
    },
    {
      name: 'David Musoke',
      role: 'Post-Surgery Patient',
      quote: 'The postoperative rehabilitation program was exceptional. The staff was patient, professional, and genuinely cared about my progress. I recovered much faster than expected.',
      rating: 5,
    },
  ];

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#0B4F6C] mb-4">
            What Our Patients Say
          </h2>
          <div className="w-20 h-1 bg-[#14B8A6] mx-auto mb-4"></div>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Real stories from real people who have experienced transformation through our care
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-[#F0F9FF] to-white rounded-2xl p-8 sm:p-12 shadow-xl">
            <div className="flex justify-center mb-6">
              <i className="ri-double-quotes-l text-5xl text-[#14B8A6]/30"></i>
            </div>

            <div className="text-center mb-8">
              <p className="text-lg text-gray-700 leading-relaxed mb-6 italic">
                "{testimonials[currentIndex].quote}"
              </p>
              <div className="flex justify-center mb-4">
                {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-xl text-[#14B8A6]"></i>
                ))}
              </div>
              <h4 className="text-xl font-bold text-[#0B4F6C] mb-1">
                {testimonials[currentIndex].name}
              </h4>
              <p className="text-sm text-gray-600">{testimonials[currentIndex].role}</p>
            </div>

            <div className="flex justify-center items-center space-x-4">
              <button
                onClick={prevTestimonial}
                className="w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-md hover:bg-[#14B8A6] hover:text-white transition-all group cursor-pointer"
              >
                <i className="ri-arrow-left-s-line text-xl text-[#0B4F6C] group-hover:text-white"></i>
              </button>

              <div className="flex space-x-2">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentIndex(index)}
                    className={`w-2.5 h-2.5 rounded-full transition-all cursor-pointer ${
                      index === currentIndex ? 'bg-[#14B8A6] w-8' : 'bg-gray-300'
                    }`}
                  ></button>
                ))}
              </div>

              <button
                onClick={nextTestimonial}
                className="w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-md hover:bg-[#14B8A6] hover:text-white transition-all group cursor-pointer"
              >
                <i className="ri-arrow-right-s-line text-xl text-[#0B4F6C] group-hover:text-white"></i>
              </button>
            </div>
          </div>

          <div className="absolute -top-8 -left-8 w-32 h-32 bg-[#14B8A6]/10 rounded-full -z-10"></div>
          <div className="absolute -bottom-8 -right-8 w-40 h-40 bg-[#0B4F6C]/5 rounded-full -z-10"></div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-16">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all cursor-pointer border-2 ${
                index === currentIndex ? 'border-[#14B8A6]' : 'border-transparent'
              }`}
            >
              <div className="flex justify-between items-start mb-3">
                <div className="w-12 h-12 bg-gradient-to-br from-[#14B8A6] to-[#0D9488] rounded-full flex items-center justify-center text-white font-bold text-lg">
                  {testimonial.name.charAt(0)}
                </div>
                <div className="flex">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm text-[#14B8A6]"></i>
                  ))}
                </div>
              </div>
              <h4 className="text-base font-bold text-[#0B4F6C] mb-1">{testimonial.name}</h4>
              <p className="text-xs text-gray-600 mb-3">{testimonial.role}</p>
              <p className="text-sm text-gray-700 line-clamp-3 italic">"{testimonial.quote}"</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}